import { activeTheme } from "src/themes";
import { lazy, Suspense } from "react";

import { loginWithGoogle } from "src/services/firebase";
import { REGISTER_FIREBASE } from "src/queries";
import { apolloClient } from "src/index";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setUserData } from "src/redux/index";
import { setLoading } from "src/redux/index";

const Template = lazy(() => import(`src/templates/${activeTheme}/components/elements/FirebaseLogin.jsx`));

function Index() {
  const dispatch = useDispatch();
  const loginGoogle = async () => {
    try {
      dispatch(setLoading(true));
      const user = await loginWithGoogle();
      const { data, errors } = await apolloClient.mutate({
        mutation: REGISTER_FIREBASE,
        variables: {
          token: user.accessToken,
        },
      });
      dispatch(setLoading(false));
      let userData = data.registerWithFirebase;
      if (userData.token) {
        dispatch(setUserData(userData.user, userData.token, userData.credit));
        window.location.href="/find-matches"
      }
    } catch (e) {
      toast.error(e.message, {
        position: "top-center",
        autoClose: 1000,
      });
      dispatch(setLoading(false));
      // console.log(e);
    }
  };
  return (
    <Suspense fallback={<p>Loading</p>}>
      <Template loginGoogle={loginGoogle} />
    </Suspense>
  );
}

export default Index;
